










































import mixins from 'vue-typed-mixins';
import { validatorInArray } from '@/utils/string';
import E2EMixin from '@/components/mixins/E2EMixin';

export default mixins(E2EMixin).extend({
  props: {
    // TODO make it required
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
    urlName: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'link',
      validator: validatorInArray(['link', 'submit', 'action']),
    },
    kind: {
      type: String,
      default: 'positive',
      validator: validatorInArray(['positive', 'negative']),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    urlTo() {
      return this.urlName ? { name: this.urlName } : this.url;
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
});
